import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../../../../Url/NodeBaseURL";
import { Button, Row, Col } from "react-bootstrap";

const AdminReviews = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const { productid } = useParams();
  const [remarks, setRemarks]= useState('');

  const [loading, setLoading] = useState(true);

  const fetchSubmissions = async () => {
    try {
      const response = await axios.get(`${baseURL}/admin/submissions`);
      const submissions = response.data || [];
      setData(submissions);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching vendor assignments:", error);
      setLoading(false);
    }
  };
  
const handleReview = (is_approved) => {
  const reviewed_by = 'admin'; 

  axios.post(`${baseURL}/admin/submissions/${productid}/review`, {
    status: is_approved ? 'approved' : 'rejected',
    is_approved,
    remarks,
    reviewed_by,
  })
  .then((res) => {
    alert("Review submitted successfully!");
    fetchSubmissions();
  })
  .catch((err) => {
    console.error("Review failed:", err);
    alert("Failed to submit review.");
  });
};


  useEffect(() => {
    fetchSubmissions();
  }, []);

useEffect(() => {
  if (data.length > 0 && productid) {
    const product = data.find((item) => String(item.id) === productid);
    if (product) {
      setRemarks(product.remarks || '');
    }
  }
}, [data, productid]);

  if (loading) return <p>Loading...</p>;
  if (productid) {
    const product = data.find((item) => String(item.id) === productid);
    
    if (!product) return <p>Product not found.</p>;

    return (
      <div className="main-container mt-3">
        <div className="payments-table-container">
          <Row className="mb-3">
            <Col className="d-flex justify-content-between align-items-center">
              <h4>Submission Details</h4>
              <Button
                className="create_but"
                onClick={() => navigate(-1)}
                style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
                size="sm"
              >
                ← Back
              </Button>
            </Col>
          </Row>

          <div style={{ overflowX: "auto" }}>
            <table className="table table-bordered border-dark-subtle">
              <tbody>
  <tr>
    <th>Bar Code</th>
    <td>{product.code}</td>
    <th>Product Name</th>
    <td>{product.product_name}</td>
  </tr>
  <tr>
    <th>Metal Type</th>
    <td>{product.metal_type}</td>
    <th>Purity</th>
    <td>{product.purity}</td>
  </tr>
  <tr>
    <th>Gross Wt</th>
    <td>{product.gross_weight}</td>
    <th>Stone Wt</th>
    <td>{product.stone_weight}</td>
  </tr>
  <tr>
    <th>W.Wt</th>
    <td>{product.wastage_weight}</td>
    <th>Total Wt</th>
    <td>{product.total_weight_av}</td>
  </tr>
  <tr>
    <th>Size</th>
    <td>{product.size}</td>
    <th>MC</th>
    <td>{product.making_charges}</td>
  </tr>
  <tr>
    <th>Rate</th>
    <td>{product.rate}</td>
    <th>Tax Amt</th>
    <td>{product.tax_amt}</td>
  </tr>
  <tr>
    <th>Total Price</th>
    <td colSpan="3">{product.total_price}</td>
  </tr>
  <tr>
    <th>Proposed MRP</th>
    <td colSpan="3">{product.proposed_mrp}</td>
  </tr>
  <tr>
    <th>Advance Payment</th>
    <td colSpan="3">{product.advance_payment}</td>
  </tr>
  <tr>
    <th>Model Name</th>
    <td colSpan="3">{product.model_name}</td>
  </tr>
  <tr>
    <th>Model Details</th>
    <td colSpan="3">{product.model_details}</td>
  </tr>
  <tr>
    <th>Image</th>
    <td colSpan="3">{product.images}</td>
  </tr>
  <tr>
  <th>Remarks</th>
  <td colSpan="3">
    <input
      type="text"
      className="form-control"
      value={remarks}
      onChange={(e) => setRemarks(e.target.value)}
      placeholder="Enter your remarks here"
    />
  </td>
</tr>

</tbody>


            </table>
            <div className="text-center mt-4">
  <div className="d-flex justify-content-center gap-3">
    <button
      className="btn btn-primary"
      style={{
        backgroundColor: "#a36e29",
        borderColor: "#a36e29",
        padding: "8px 24px",
        fontWeight: "bold",
      }}
      onClick={() => handleReview(true)}
    >
      Approve
    </button>

    <button
      className="btn btn-danger"
      style={{
        padding: "8px 24px",
        fontWeight: "bold",
      }}
     onClick={() => handleReview(false)}
    >
      Reject
    </button>
  </div>
</div>

          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-container">
      <div className="payments-table-container">
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h3>Submissions of all vendors</h3>
            <Button
              className="create_but"
              onClick={() => navigate("/orderstable")}
              style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
            >
              ← Back
            </Button>
          </Col>
        </Row>

        <div style={{ overflowX: "auto" }}>
          <table className="table table-bordered">
            <thead className="thead-light">
              <tr>
                <th>Bar Code</th>
                <th>Product Name</th>
                <th>Metal Type</th>
                <th>Purity</th>
                <th>Gross Wt</th>
                <th>Stone Wt</th>
                <th>W.Wt</th>
                <th>Total Wt</th>
                <th>Size</th>
                <th>MC</th>
                <th>Rate</th>
                <th>Tax Amt</th>
                <th>Total Price</th>
                <th>Status</th>
                <th>Review</th>
              </tr>
            </thead>
            <tbody>
              {data.map((product, index) => (
                <tr key={index}>
                  <td>{product.code}</td>
                  <td>{product.product_name}</td>
                  <td>{product.metal_type}</td>
                  <td>{product.purity}</td>
                  <td>{product.gross_weight}</td>
                  <td>{product.stone_weight}</td>
                  <td>{product.wastage_weight}</td>
                  <td>{product.total_weight_av}</td>
                  <td>{product.size}</td>
                  <td>{product.making_charges}</td>
                  <td>{product.rate}</td>
                  <td>{product.tax_amt}</td>
                  <td>{product.total_price}</td>
                  <td>{product.status}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="outline-primary"
                      style={{ padding: "2px 6px", fontSize: "12px" }}
                      onClick={() =>
                        navigate(`/admin/submissions/${product.id}`)
                      }
                    >
                      Review
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminReviews;
